import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { NbcSharedModule } from "../shared/shared.module";
import { ContactDetailsComponent } from "./contact-details/contact-details.component";
import { TabsModule } from "ngx-bootstrap/tabs";
import { ContactProfileComponent } from "./contact-details/profile/contact-profile.component";
import { ModalContactSapComponent } from "./component/sap/modal-contact-sap-result";
import { ModalContactCommentComponent } from "./component/contact-comments/modal-contact-comments";
import { ModalContactIdmComponent } from "./component/idm/modal-contact-idm-result";
import { ModalContactTypeChangeComponent } from "./component/contact-type/modal-contact-type-change";
import { NgPipesModule, OrderByPipe } from "ngx-pipes";
import { ContactWorkScheduleComponent } from "./contact-details/workschedule/contact-work-schedule.component";
import { ContactWorkHistoryComponent } from "./contact-details/workhistory/contact-work-history.component";
//import { ModalWorkScheduleAddActivity } from './contact-details/workschedule/activity/modal-work-schedule-add-activity';
import { FullCalendarModule } from "@fullcalendar/angular";
import { ModalModule, BsModalService } from "ngx-bootstrap/modal";
import { ContactWorkScheduleAllComponent } from "./contact-details/workscheduleall/contact-work-schedule-all.component";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import { ModalAddNewContactComponent } from "./component/addContact/modal-add-new-contact";
import { NbcPhoneNumberComponent } from "../shared/component/nbc-phone-number/nbc-phone-number.component";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { PositionRequestComponent } from "./contact-details/position-request/position-request.component";
///FullCalendarModule.registerPlugins([interactionPlugin, dayGridPlugin]); //TODO: Revisit

@NgModule({
    declarations: [
        ContactDetailsComponent,
        ContactProfileComponent,
        ModalContactTypeChangeComponent,
        ModalContactIdmComponent,
        ModalContactCommentComponent,
        ModalContactSapComponent,
        ContactWorkScheduleComponent,
        ContactWorkHistoryComponent,
        //NbcPaginationLabelComponent,
        ContactWorkScheduleAllComponent,
        ModalAddNewContactComponent,
        NbcPhoneNumberComponent,
        PositionRequestComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        RouterModule,
        NbcSharedModule,
        NgPipesModule,
        FullCalendarModule,
        //PaginationModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        BsDatepickerModule.forRoot(),
        TypeaheadModule.forRoot(),
        TooltipModule.forRoot()
    ],
    providers: [OrderByPipe],
})
export class ContactModule {}
